import agent from 'local/test/agent';
import testIpType from 'local/test/testIpType';
import askLocationPermissions from 'local/components/modals/askLocationPermissions';

/**
 * Start test. This can only happen after the configuration event as
 * we need a server to test against. If no server is found, an error
 * is dispatched. Once a server is found, we send a message to the
 * agent to start the test.
 *
 * Once the test is started, the agent will start sending test events such
 * as taskStart, taskProgress and taskComplete.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#instructions-that-the-agent-should-be-able-to-receive}
 */
export default function start(m) {
	testIpType(m).finally(() => {
		const server = m.data.getServer();
		const send = () => {
			agent.send({
				method: 'startTest',
				args: {
					serverUrl: server.url,
					userKey: m.data.hashkey,
				},
			});
		};

		const checkPositionAndStart = () => {
			navigator.geolocation.getCurrentPosition((position) => {
				agent.send({
					method: 'setConfigurationOption',
					args: {
						'Report.lat': position.coords.latitude,
						'Report.lon': position.coords.longitude,
						'Report.accuracy': position.coords.accuracy,
					},
				});

				send();
			}, (error) => {
				console.error('Error getting location', error);

				send();
			}, {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			});
		};

		if (!server) {
			m.dispatch('error', {
				errno: 'NO_SERVER',
				error: 'No server found',
			});

			return;
		}

		m.setData({ server });
		m.dispatch('started');

		if ("geolocation" in navigator) {
			askLocationPermissions((share) => {
				if (share) {
					checkPositionAndStart();
				} else {
					send();
				}
			});
		} else {
			send();
		}
	});
}
